/**
 * Polarheat discrete range filters for numeric Shopify metafields.
 * Keeps Shopify's native exact-value filtering and presents it as a min/max slider.
 */
(() => {
  if (window.PolarheatRangeFilters) return;
  window.PolarheatRangeFilters = true;
  document.documentElement.dataset.polarheatRangeFilters = 'ready';

  const syncRange = (root) => {
    const low = root.querySelector('[data-ph-low]');
    const high = root.querySelector('[data-ph-high]');
    const max = Number(low.max) || 1;

    if (Number(low.value) > Number(high.value)) {
      if (document.activeElement === low) low.value = high.value;
      else high.value = low.value;
    }

    const labels = (root.dataset.values || '').split('|');
    root.querySelector('[data-ph-low-output]').textContent = labels[Number(low.value)] || '';
    root.querySelector('[data-ph-high-output]').textContent = labels[Number(high.value)] || '';

    const track = root.querySelector('.ph-range-filter__track');
    track.style.setProperty('--ph-low', (Number(low.value) / max * 100) + '%');
    track.style.setProperty('--ph-high', (Number(high.value) / max * 100) + '%');
  };

  const preservePreviewParameters = (form) => {
    const current = new URL(window.location.href);
    ['preview_theme_id', '_ab', '_fd', '_sc'].forEach((name) => {
      const value = current.searchParams.get(name);
      if (!value || form.querySelector('input[name="' + name + '"]')) return;
      const hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = name;
      hidden.value = value;
      form.appendChild(hidden);
    });
  };

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-ph-range-handle]')) return;
    event.stopPropagation();
    syncRange(event.target.closest('[data-ph-range]'));
  }, true);

  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-ph-range-handle]')) return;
    event.stopPropagation();

    const root = event.target.closest('[data-ph-range]');
    syncRange(root);

    const low = Number(root.querySelector('[data-ph-low]').value);
    const high = Number(root.querySelector('[data-ph-high]').value);
    const boxes = Array.from(root.querySelectorAll('[data-ph-range-value]'));

    boxes.forEach((box, index) => {
      if (!box.disabled) box.checked = index >= low && index <= high;
    });

    const form = root.closest('form');
    if (form) preservePreviewParameters(form);

    const trigger = boxes.find((box) => !box.disabled);
    if (trigger) trigger.dispatchEvent(new Event('input', { bubbles: true }));
  }, true);
})();
